import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PanelCollapseComponent} from './panel-collapse.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import { default as pjson } from '../../../../../package.json';

@NgModule({
  declarations: [
    PanelCollapseComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    MatFormFieldModule,
    MatInputModule,

    CommonModule
  ]
})
export class PanelCollapseModule {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(PanelCollapseComponent, 'sc-panel', this.injector, pjson.version);
    customElementService.convertToCustomElement(PanelCollapseComponent, 'sc-panel-collapse', this.injector, pjson.version);
    customElementService.convertToCustomElement(PanelCollapseComponent, 'sc-static-html', this.injector, pjson.version, {
        isStaticPanel: true,
        isCollapsiblePanel: false
    });
  }
}
